var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dm_detail"},[_c(_vm.componentName,{tag:"component",attrs:{"detail":_vm.detail}}),_c('DmDetailDianping',{attrs:{"detail":_vm.dpDetail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }